import { HourlyWeatherData } from "../../../lib/Types";

export interface WeatherConfig {
  field: keyof HourlyWeatherData;
  color: string;
  min: number;
  max: number;
}

export const weatherConfig: Record<string, WeatherConfig> = {
  rain: {
    field: "rain",
    color: "rgba(30, 136, 229, 1)",
    min: 0,
    max: 10,
  },
  cloud_cover: {
    field: "cloud_cover",
    color: "rgba(189, 189, 189, 1)",
    min: 0,
    max: 100,
  },
  temperature_2m: {
    field: "temperature_2m",
    color: "rgba(255, 213, 79, 1)",
    min: -30,
    max: 120,
  },
};
